import { ErrorMessageWrapper } from "@/common/components/ErrorMessageWrapper";
import ListHeader from "@/common/components/ListHeader";
import Table from "@/common/components/Table";
import TextField from "@/common/components/TextField";
import { useFilterParams } from "@/common/hooks/useFilterParams";
import { Mapper } from "@/common/services/mapper";
import { SearchIcon, Trophy } from "lucide-react";
import useDebounce from "@/common/hooks/useDebounce";
import { useTmaisRaffles } from "@/common/hooks/queries/useTmaisRaffles";
import { TmaisRaffleData, TmaisRaffleTableItem } from "../../types/tmaisRaffles.type";
import { TmaisRafflesTransformer } from "../../services/tmaisRafflesTransformer";
import { tmaisRafflesColumns } from "../../constants/tmaisRafflesColumns.constant";

const TmaisRafflesList = () => {
  const { filterParams, setFilterParams } = useFilterParams();
  const [search, setSearch] = useDebounce(filterParams.search || '');
  
  const {
    data: raffles = [],
    meta,
    isPending,
    error: rafflesError = {} as any,
    isFetching,
    refetch,
  } = useTmaisRaffles<TmaisRaffleTableItem[]>({
    filters: {
      search: search,
      page: filterParams.page || 1,
    },
    mapper: Mapper.mapWithTransformer<TmaisRaffleData[], TmaisRaffleTableItem[]>({
      transformer: TmaisRafflesTransformer.tableTransformer(),
    }),
  });

  const errorStatus = rafflesError?.status;
  const disableCreateButton = isPending || errorStatus === 403;

  return (
    <div className="flex flex-col gap-6">
      <ListHeader
        Icon={<Trophy className="size-10" strokeWidth={1.5} />}
        title="Sorteios" 
        disableCreateButton={disableCreateButton}
        operationKlassToCheckPermission="Admin::Tmais::Raffles::Create"
        createButtonText="Cadastrar sorteio"
      />

      <ErrorMessageWrapper
        className="h-[calc(100vh-128px)]"
        statusCode={errorStatus}
        refetchFunction={refetch}
      >
        <div className="h-[calc(100vh-128px)] overflow-auto flex flex-col gap-6">
          <div className="flex flex-col gap-4">
            <TextField
              LeftIcon={<SearchIcon />}
              placeholder="Pesquisar"
              className="rounded-sm shadow-[4px_0px_16px_0px_rgba(0,_0,_0,_0.5)]"
              onChange={(e) => {
                const value = (e.target as HTMLInputElement).value;
                setSearch(value);
                setFilterParams((prev) => ({ ...prev, search: value, page: 1 }));
              }}
              value={filterParams.search || ''}
            />
          </div>

          <Table
            columns={tmaisRafflesColumns}
            rows={raffles || []}
            isLoadingData={isPending || isFetching}
            page={filterParams.page || 1}
            totalPages={meta?.total_pages || 1}
            totalCount={meta?.total || 0}
            hasPagination
            setPage={(page) =>
              setFilterParams((prev: any) => ({ ...prev, page }))
            }
            rowEmptyValue="--"
          />
        </div>
      </ErrorMessageWrapper>
    </div>
  );
};

export default TmaisRafflesList;